export const ADDITIONAL_DETAILS_INITIAL_LOAD = "ADDITIONAL_DETAILS_INITIAL_LOAD";

export const loadInitialAdditionalDetails = (data) => {
    return {
        type: ADDITIONAL_DETAILS_INITIAL_LOAD,
        data
    }
}